import './Toast.less';
import React from 'react';
import Icon from '../../components/icon/Icon';
import {
    TOAST_SUCCESS,
    TOAST_INFO,
    TOAST_ERROR,
    TOAST_WARN
} from './Toasts';
import {sanitizeHtmlInline} from "../../utils/html";

const PADDING = 15;
const MARGIN = 5;

export default class Toast extends React.Component {
    /**
     *
     * @type {HTMLDivElement}
     */
    toast = null;

    /**
     *
     * @type {HTMLDivElement}
     */
    inner = null;

    removeTimer = null;

    componentDidMount() {
        const {type} = this.props;
        const stableDur = getStableDuration(type);

        this.grow();
        this.removeTimer = setTimeout(this.collapseThenRemove, stableDur);
    }

    collapseThenRemove = () => {
        clearTimeout(this.removeTimer);
        this.removeTimer = null;

        const {type, remove} = this.props;
        const transDur = getTransitionDuration(type);
        this.collapse();
        setTimeout(() => remove(), transDur);
    };

    grow = () => {
        this.toast.style.height = this.inner.getBoundingClientRect().height + 'px';
        this.toast.style.paddingTop = PADDING + 'px';
        this.toast.style.paddingBottom = PADDING + 'px';
        this.toast.style.marginBottom = MARGIN + 'px';
        this.toast.style.opacity = '1';
    };

    collapse = () => {
        this.toast.style.height = '0px';
        this.toast.style.paddingTop = '0px';
        this.toast.style.paddingBottom = '0px';
        this.toast.style.marginBottom = '0px';
        this.toast.style.opacity = '0';
    };

    render() {
        const {type, children} = this.props;
        const transDur = getTransitionDuration(type);

        return <div
            className={`toast toast-${type}`}
            style={{
                boxSizing: 'content-box',
                height: 0,
                opacity: 0,
                padding: `0 ${PADDING}px`,
                margin: `0 0 ${MARGIN}px 0`,
                transition: `all ${transDur}ms`
            }}
            ref={el => this.toast = el}
        >
            <div className="inner" ref={el => this.inner = el}>
                <div className="ic-holder">
                    <Icon name={getIconName(type)}/>
                </div>
                <div className="message">
                    {
                        typeof children === 'string'
                            ? <div dangerouslySetInnerHTML={{__html: sanitizeHtmlInline(children)}}/>
                            : children
                    }
                </div>
                {
                    type === TOAST_ERROR &&
                    <div>
                        <button
                            type="button"
                            className="remove-button"
                            onClick={() => this.collapseThenRemove()}>
                            <Icon name="times"/>
                        </button>
                    </div>
                }
            </div>
        </div>;
    }
}

function getIconName(type) {
    switch (type) {
        case TOAST_SUCCESS:
            return 'tick';
        case TOAST_INFO:
            return 'info-circle';
        case TOAST_ERROR:
        case TOAST_WARN:
            return 'caution-circle';
    }
}

function getStableDuration(type) {
    switch (type) {
        case TOAST_SUCCESS:
        case TOAST_INFO:
            return 4000;
        case TOAST_WARN:
            return 6000;
        case TOAST_ERROR:
            return 30000;
    }
}

function getTransitionDuration(type) {
    return 300;
}
